module.exports = {"liang":[{"name":"广州市","value":10},{"name":"北京市","value":20},{"name":"上海市","value":30},{"name":"成都","value":40},{"name":"深圳市","value":50},{"name":"铜仁市","value":60},{"name":"黔西南","value":70},{"name":"黔东南","value":80},{"name":"黔南","value":80}],"number":[{"name":"广州市","value":67},{"name":"北京市","value":20},{"name":"上海市","value":50},{"name":"成都","value":70},{"name":"深圳市","value":60},{"name":"铜仁市","value":63},{"name":"黔西南","value":10},{"name":"黔东南","value":80},{"name":"黔南","value":160}]}


//////////////////
// WEBPACK FOOTER
// ./src/module/monitoringCenter/jsons/json19.json
// module id = NRyY
// module chunks = 63